<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editData(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-table-edit</v-icon>
                </a>
              </template>
              <span>{{ $t("TableData") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:action-buttons>
            <v-btn small color="primary" @click.prevent="onImport">
              {{ $t("Import") }}
              <v-icon>mdi-application-import</v-icon>
            </v-btn>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <InternalTableModal :ref="modalKey" @on-item-saved="onItemSaved" />
    <InternalTableDataModal :ref="internalTableDataModalKey" @on-item-saved="onItemSaved"/>
    <InternalTableImportModal
      :ref="internalTableImportModalKey"
      @on-imported="onItemSaved"
    />
  </div>
</template>

<script>
import InternalTableService from "@/services/InternalTableService";
import InternalTableModal from "@/components/administration/internalTable/InternalTableModal";
import InternalTableDataModal from "@/components/administration/internalTable/InternalTableDataModal";
import InternalTableImportModal from "@/components/administration/internalTable/InternalTableImportModal";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    InternalTableModal,
    InternalTableDataModal,
    InternalTableImportModal,
  },
  data() {
    return {
      title: this.$t("InternalTables"),
      grid: {
        key: "internalTableGrid",
        dataSource: InternalTableService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
        ],
      },
      modalKey: "modalInternalTable",
      internalTableDataModalKey: "internalTableDataModal",
      internalTableImportModalKey: "internalTableImportModal",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
    internalTableDataModalInstance() {
      return this.$refs[this.internalTableDataModalKey];
    },
    internalTableImportModalInstance() {
      return this.$refs[this.internalTableImportModalKey];
    },
  },
  methods: {
    editData(dto) {
      this.internalTableDataModalInstance.edit(dto);
    },
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          InternalTableService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(this.$t("InternalTable") + " " + this.$t("DeletedSuccessfullyFem"));
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
    onImport() {
      this.internalTableImportModalInstance.show();
    },
  },
};
</script>